<div class="container">
  <div class="schedule-rules-filters">
    <app-schedule-rules-filters
      [shopsList]="shopsList()"
      [usersList]="usersList()"
      [rulesList]="scheduleRules()"
      (filteredRules)="filteredRules.set($event)"
    ></app-schedule-rules-filters>
  </div>

  <div class="schedule-rules-list">
    <app-schedule-rules-infinite-scroll
      [allRules]="scheduleRules()"
      [filteredRules]="filteredRules()"
      [shopNameMap]="shopNameMap()"
      [userNameMap]="userNameMap()"
      (toggleActive)="onToggleActive($event)"
      (updateWeekdays)="onUpdateWeekdays($event)"
      (requestUpdateFromAdmin)="onRequestSingleShopUpdateFromAdmin($event)"
      (updateSchedulingRequirements)="onUpdateSchedulingRequirements($event)"
    ></app-schedule-rules-infinite-scroll>
  </div>
</div>

<visio-fab
  icon="store-icon"
  [label]="ruleUpdateLoading() ? 'Atualizando...' : 'Atualizar todas as regras'"
  [disabled]="ruleUpdateLoading()"
  (click)="requestUpdateFromAdmin()"
></visio-fab>

<visio-popup id="schedule-recurrence-popup"></visio-popup>
